module.exports = __webpack_public_path__ + "img/facility-preview-placeholder.edddbc13.jpg";